// Gedeelde query voor het overzicht en de tellers in de navigatie.
import { useQuery } from "@tanstack/react-query";
import { api } from "./api.ts";

export interface Overview {
  counts: Record<string, number>;
  recentLeads: { id: string; kind: string; status: string; received_at: string; locale: string; full_name: string; reference: string | null }[];
  tasks: { id: string; title: string; due_at: string | null; priority: string; related_type: string | null; related_id: string | null }[];
  sites: { id: string; name: string; key: string; channel: string | null; live_revision: number | null; live_generation: number | null; intended_generation: number | null; promoted_at: string | null; last_build_status: string | null; host: string | null }[];
  activity: { action: string; object_type: string; object_id: string; summary: string; actor: string; occurred_at: string }[];
  ai: { spentMinor: number; limitMinor: number | null; hardStop: boolean; currency: string };
  covers: string[];
}

export function useOverview(enabled = true) {
  return useQuery({ queryKey: ["overview"], queryFn: () => api.get<Overview>("/v1/overview"), refetchInterval: 60_000, enabled });
}
